import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'

// Stack of elements spread apart using justify-between

export type SpreadProps = {
  as?: React.ElementType
} & React.ComponentPropsWithoutRef<React.ElementType> &
  VariantProps<typeof spreadVariants>

const spreadVariants = cva('flex justify-between', {
  variants: {
    direction: {
      row: 'flex-row w-full',
      column: 'flex-col h-full',
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
    },
  },
  defaultVariants: {
    direction: 'row',
    align: 'start',
  },
})

export function Spread({ as: Component = 'div', ...props }: SpreadProps) {
  const { direction, align, className, ...rest } = props

  return <Component className={cn(spreadVariants({ direction, align }), className)} {...rest} />
}
